const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    title: {
      title: 'عنوان',
      type: 'string',
      unit: 'unit',
    },
    barcode: {
      title: 'بارکد',
      type: 'number',
    },
    shop_id: {
      title: 'فروشگاه',
      type: 'string',
    },
    booth_id: {
      title: 'غرفه',
      type: 'string',
    },
    brand_id: {
      title: 'برند',
      type: 'string',
    },
    category_id: {
      title: 'دسته بندی',
      type: 'string',
    },
    co_price: {
      type: 'number',
      title: 'قیمت کارخانه',
    },
    me_price: {
      type: 'number',
      title: 'قیمت فروشگاه',
    },
    stock: {
      type: 'number',
      title: 'موجودی',
    },
    max_number_buy: {
      type: 'number',
      default: 5,
      minimum: 0,
      title: 'حداکثر تعداد قابل خرید',
    },
    nonexistent_number: {
      type: 'number',
      default: 5,
      minimum: 0,
      title: 'حداقل تعداد ناموجودی',
    },
    is_active: {
      type: 'number',
      title: 'فعالیت',
      oneOf: [
        { const: 1, title: 'فعال' },
        { const: 0, title: 'غیرفعال' },
      ],
    },
    introtext: {
      title: 'توضیحات محصول',
      type: 'string',
      format: 'textarea',
    },
    packaged_items: {
      type: 'array',
      title: 'محصولات',
      minItems: 1,
      items: {
        type: 'object',
        title: '',
        required: ['product_shop_id', 'quantity'],
        properties: {
          product_shop_id: {
            title: 'محصول',
            type: 'string',
          },
          quantity: {
            title: 'تعداد',
            type: 'number',
          },
        },
      },
    },
  },
});

export default schema;
